"use client";
import * as React from "react";

type Props = { lat: number; lng: number };

export default function GooglePropertyMap({ lat, lng }: Props) {
  const ref = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (!ref.current) return;

    let cancelled = false;
    let map: any = null;
    let marker: any = null;
    let t: number | null = null;

    const tryInit = () => {
      if (cancelled || !ref.current) return false;
      const g = (window as any).google;
      if (!g?.maps) return false;

      map = new g.maps.Map(ref.current, {
        center: { lat, lng },
        zoom: 14,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
      });

      marker = new g.maps.Marker({ position: { lat, lng }, map });
      return true;
    };

    if (!tryInit()) {
      let tries = 0;
      t = window.setInterval(() => {
        tries += 1;
        if (tryInit() || tries > 60) {
          if (t) window.clearInterval(t);
          t = null;
        }
      }, 100) as any;
    }

    return () => {
      cancelled = true;
      if (t) window.clearInterval(t);
      marker?.setMap?.(null);
      map = null;
    };
  }, [lat, lng]);

  // Σημαντικό: ο γονιός πρέπει να έχει height. Εδώ αφήνουμε 100%.
  return <div ref={ref} style={{ width: "100%", height: "100%", borderRadius: 12 }} />;
}
